import { Container } from 'pixi.js';
import type { CollectionEventVisualConfig } from '../types';
import { VisualConfigType } from '../types';
import type { CollectionEventIconLayoutInstance } from './collectionEventPredefinedStyles';
import { collectionEventPredefinedStyles } from './collectionEventPredefinedStyles';
import { playLayoutAnimation } from '../../../libs/layouts/layoutAnimations/playLayoutAnimation';

export class CollectionTokenIconView extends Container {
  private readonly layout: CollectionEventIconLayoutInstance;

  constructor(visualStyle: CollectionEventVisualConfig) {
    super();

    if (visualStyle.configType === VisualConfigType.Custom) {
      throw new Error('Custom visuals are not supported yet');
    }

    this.layout = collectionEventPredefinedStyles[visualStyle.visualType].icon();
    this.layout.root.props({
      parent: this,
    });
  }

  public showAmount(amount: number): this {
    this.layout.amountText.props({
      alpha: 1,
      visible: true,
      text: `+${amount}`,
    });

    return this;
  }

  public showAmountToLose(amount: number): this {
    this.layout.amountText.props({
      alpha: 1,
      visible: true,
      text: `x${amount}`,
    });

    return this;
  }

  public async animateCollect(amount: number): Promise<void> {
    this.layout.amountText.text = `+${amount}`;
    await playLayoutAnimation(this.layout, 'In_Game_Collect', false);
  }
}
